<nav #navbar class="navbar navbar-expand-lg navbar-absolute navbar-transparent top-0 customZ-index">
  <div class="container-fluid" [ngClass]="{ 'nav-closed': open === false , 'nav-fixed': open === true}">
    <div class="navbar-wrapper">
      <div class="navbar-minimize">
        <button id="minimizeSidebar" class="btn btn-pink btn-icon btn-round" (click)="minimizeSidebar()">
          <i class="nc-icon nc-minimal-right text-center visible-on-sidebar-mini"></i>
          <i class="nc-icon nc-minimal-left text-center visible-on-sidebar-regular"></i>
        </button>
      </div>
      <div class="navbar-toggle" (click)="sidebarToggle()">
        <button type="button" class="navbar-toggler">
          <span class="navbar-toggler-bar bar1"></span>
          <span class="navbar-toggler-bar bar2"></span>
          <span class="navbar-toggler-bar bar3"></span>
        </button>
      </div>
      <a class="navbar-brand" routerLink=".." (click)="location.back()">{{getTitle()}}</a>
    </div>
    <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navigation" aria-controls="navigation-index" aria-expanded="false" aria-label="Toggle navigation" (click)="open = !open"
      >
      <span class="navbar-toggler-bar navbar-kebab"></span>
      <span class="navbar-toggler-bar navbar-kebab"></span>
      <span class="navbar-toggler-bar navbar-kebab"></span>
    </button>

    
    <div class="collapse navbar-collapse justify-content-end" id="navigation">
      <!-- <form>
        <div class="input-group no-border">
          <input type="text" value="" class="form-control" placeholder="Search...">
          <div class="input-group-append">
            <div class="input-group-text">
              <i class="nc-icon nc-zoom-split"></i>
            </div>
          </div>
        </div>
      </form> -->


      <div class="enterprise-select">
        <select class="btn btn-pink btn-enterprise-selection" 
        (change)="onOptionChange($event)"
        >   
        <option 
            *ngFor="let company of Companys"
            [value]="company.companyName"
            [attr.selected]="bindCompany === company.tenantId ? true : null"
          >{{company.companyName}}</option>

        </select>
      </div>

      <ul class="navbar-nav">

        <!-- Bell Notification -->
        <li id="bell-notification-toggle" class="pl-md-4 nav-item dropdown bell">         
          <a class="nav-link dropdown-toggle" href="#bell-notification-toggle" id="navbarDropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            <i class="nc-icon nc-bell-55"></i>
            <span *ngIf="notificationCout.nCount > 0" class="bell-notification">{{notificationCout.nCount}}</span>
            <p>
              <span class="d-lg-none d-md-block">Notificações</span>
            </p>
          </a>
          <div class="dropdown-menu dropdown-menu-right bell-mobile-dropdown overflow-auto" aria-labelledby="navbarDropdownMenuLink">
            <span *ngIf="pendencyList.length === 0" class="p-3 d-block">Notificações vazias</span>
            <ul *ngFor="let notification of pendencyList; index as i" class="px-2 notification-hover">
              <a (click)="onClickNotification(notification.Link)">
                <li class="list-unstyled row shadow-sm py-2 overflow-auto">
                    <div class="d-block col-6"><p><strong>Empresa:</strong> </p> {{notification.Empresa}}</div>
                    <div class="d-block col-6"><p><strong>Documento:</strong></p> {{notification.Documento}}</div>                    
                    <div class="d-block col-6"><p><strong>Emissão:</strong></p> {{notification.Emissao}}</div>
                    <div class="d-block col-6"><p><strong>Nível:</strong></p> {{notification.Nivel}}</div>
                    <div class="d-block col-6"><p><strong>Tipo:</strong></p> {{notification.Tipo}}</div>
                    <div class="d-block col-6"><p><strong>Usuário:</strong></p> {{notification.Usuario}}</div>
                    <div class="d-block col-11"><p><strong>Cliente:</strong></p> {{notification.nameKnown}}</div>
                </li>
              </a>
            </ul>
          </div>
        </li>
        <!-- Bell Notification -->
        
        <!-- <li class="nav-item">
          <a class="nav-link btn-magnify" href="javascript:void(0)">
            <i class="nc-icon nc-layout-11"></i>
            <p>
              <span class="d-lg-none d-md-block">Stats</span>
            </p>
          </a>
        </li>
        <li class="nav-item btn-rotate dropdown">
          <a class="nav-link dropdown-toggle" href="pablo" id="navbarDropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            <i class="nc-icon nc-bell-55"></i>
            <p>
            <span class="d-lg-none d-md-block">Some Actions</span>
            </p>
          </a>
          <div class="dropdown-menu dropdown-menu-right" aria-labelledby="navbarDropdownMenuLink">
            <a class="dropdown-item" href="javascript:void(0)">Action</a>
            <a class="dropdown-item" href="javascript:void(0)">Another action</a>
            <a class="dropdown-item" href="javascript:void(0)">Something else here</a>
          </div>
        </li> -->
        <li class="px-md-3 nav-item btn-rotate dropdown">
          <div>
            <button class="btn-logout d-flex justify-content-center align-items-center" style="height: 40px; width: 60px" data-toggle="modal" data-target="#modalLogout">
              <i class="nc-icon nc-button-power"></i>
            </button>
          </div>
          <!-- <a class="nav-link dropdown-toggle" href="pablo" id="navbarDropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            <i class="nc-icon nc-settings-gear-65"></i>
            <p>
              <span class="d-lg-none d-md-block">Some Actions</span>
            </p>
          </a>
          <div class="dropdown-menu dropdown-menu-right" aria-labelledby="navbarDropdownMenuLink">
            <button class="dropdown-item" (click)="logout()">Logout</button>
          </div> -->
        </li>
      </ul>
    </div>

    
  </div>
</nav>

<!-- small modal -->
<div class="modal fade modal-primary mt-5" id="modalLogout" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-sm">
    <div class="modal-content">
      <div class="modal-header justify-content-center">
        <div class="modal-profile ml-auto mr-auto">
          <i class="nc-icon nc-button-power"></i>
        </div>
      </div>
      <div class="modal-body">
        <p class="font-weight-bold text-muted">Tem Certeza Que Deseja Sair?</p>
      </div>
      <div class="modal-footer">
        <div class="left-side">
          <button type="button" class="btn btn-link btn-gtex" data-dismiss="modal" (click)="logout()">Sair</button>
        </div>
        <div class="divider"></div>
        <div class="right-side">
          <button type="button" class="btn btn-link btn-link" data-dismiss="modal">Cancelar</button>
        </div>
      </div>
    </div>
  </div>
</div>
<!--    end small modal -->